<template>
    <div class="flex-layout tender-list">
        <list-layout-paper>
            <div slot="header-search">
                <div class="header-search-top" v-if="!isProjectNotice">
                    <el-radio-group v-model="valueradius" @change="selectType">
                        <el-radio label="0">全部</el-radio>
                        <el-radio label="20">招标公告</el-radio>
                        <el-radio label="10">通知公告</el-radio>
                        <el-radio label="30">中标公告</el-radio>
                    </el-radio-group>
                </div>
                <div class="header-search-bottom">
                    <el-input v-model="searchInfo.noticeCode" placeholder="公告编号" size="mini" clearable></el-input>
                    <el-input v-model="searchInfo.noticeTitle" placeholder="公告标题" size="mini" clearable></el-input>
                    <mSelect class="el-input" :optionNum="'SU_NOTICE_STATUS'" :value="searchInfo.noticeStatus" :placeholder="'公告状态'" :filterable="true" @input="getNoticeStatus"></mSelect>
                    <mSelect v-if="!isProjectNotice" class="el-input" :optionNum="'SU_NOTICE_SCOPE'" :value="searchInfo.noticeScope" :placeholder="'公告范围'" :filterable="true" @input="getNoticeScope"></mSelect>
                    <mSelect v-if="!isProjectNotice" class="el-input" :optionNum="'SU_BID_TYPE'" :value="searchInfo.bidType" :placeholder="'招标方式'" :filterable="true" @input="getBidType"></mSelect>
                    <mSelect class="el-input professional-company" :optionNum="'SYS_PROFESSIONAL_COMPANY'" :placeholder="'专业公司'" collapse-tags :multiple-limit="5" :value="searchInfo.professionalCompanyList" :multiple="true" :filterable="true" @input="getProfessionalCompany"></mSelect>
                    <mSelect class="el-input professional-company" :optionNum="'SRM_CONTRACT_IS_GROUP_CUSTOMER'" placeholder="客户类型" :value="searchInfo.customerTypeList" collapse-tags :multiple="true" :filterable="true"  @input="getCustomerType"></mSelect>
                    <mSelect v-if="!isProjectNotice" class="el-input" :optionNum="'SRM_YES_NO'" :value="searchInfo.isRecall" :placeholder="'是否召回公告'" :filterable="true" @input="getRecall"></mSelect>
                    <el-date-picker
                        class="tender-list-date-picker"
                        v-model="searchInfo.timeRange"
                        type="datetimerange"
                        align="right"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                        format="yyyy-MM-dd HH:mm:ss">
                    </el-date-picker>
                    <span v-has="'01000005'" class="padding-left"><el-button class="bigData-btn-search" type="primary" size="mini" @click="searchFn">查 询</el-button></span>
                </div>
            </div>

            <div slot="header-button" class="header-button">
                <el-tooltip effect="dark" content="新增" placement="bottom" v-has="'01000001'">
                    <el-button type="primary" size="mini" icon="el-icon-plus" @click="addNotice(0)"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="导出" placement="bottom" class="header-button-btn" v-has="'01000002'">
                    <el-button icon="el-icon-download" size="mini" :loading="exportLoading" @click="exportNoticeFn"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="刷新" placement="bottom" class="header-button-btn" v-has="'01000003'">
                    <el-button icon="el-icon-refresh" size="mini" @click="refreshFn"></el-button>
                </el-tooltip>
                <el-tooltip effect="dark" content="列配置" placement="bottom" class="header-button-btn" v-has="'01000004'">
                    <el-button icon="el-icon-setting" size="mini" @click="colDispose"></el-button>
                </el-tooltip>
            </div>

            <el-table slot="list" v-loading="loading" :data="announceList" @row-dblclick="handleRowDblClick" border stripe ref="table" class="tab-list" height="200">
                <el-table-column v-for="(item, index) in (!isProjectNotice ? columnsList : columnsList2)"
                    :key="index"
                    :prop="item.prop"
                    :label="item.label"
                    :align="item.prop === 'noticeTitle' ? '' :'center'"
                    :min-width="item.width?item.width : ''">
                    <template slot-scope="scope" >
                        <div v-if="item.prop === 'noticeStatus'" >
                            <span class="point"
                                :style="{'background': scope.row.noticeStatus === '10'
                                ? '#FF8800' : scope.row.noticeStatus === '20'
                                ? '#00BCBF' : scope.row.noticeStatus === '40'
                                ? '#ED0000' : scope.row.noticeStatus === '30'
                                ? '#00D082' : scope.row.noticeStatus === '50'
                                ? '#D8D8D8' : '#ffee44'}">
                            </span>
                            {{scope.row.noticeStatusText}}
                        </div>
                        <div v-else-if="item.prop === 'isRecallText'" :class="{ 'recall-text-yes': scope.row.isRecallText === '是' }">
                            {{scope.row.isRecallText}}
                        </div>
                        <!-- 项目公告-报名明细 -->
                        <div v-else-if="isProjectNotice && item.prop === 'enrollDetailTotal'" class="enrollDetailTotal-text" @click="onShowEnrollDetail(scope.row)">
                            {{ scope.row.enrollDetailTotal || '0'}}
                        </div>
                        <div v-else>{{codeList.indexOf(item.prop)>-1?scope.row[item.prop + 'Text']:scope.row[item.prop]}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="action" label="操作" width="250" align="center" fixed="right">
                    <template slot-scope="scope">
                        <span v-has="'01000020'" class="action-span-btn" v-if="!(scope.row.noticeStatus === '00' || scope.row.noticeStatus === '10' || scope.row.noticeStatus === '40')">
                            <el-button size="mini" type="text" @click="addNotice(scope.row,'PRIVILEGE')">特权修改</el-button></span>
                        <span v-has="'01000007'" class="action-span-btn"><el-button v-if="scope.row.noticeStatus === '00' || scope.row.noticeStatus === '10' || scope.row.noticeStatus === '40'"
                            size="mini" type="text" @click="addNotice(scope.row)">编辑</el-button></span>
                        <span v-has="'01000006'" class="action-span-btn"><el-button size="mini" type="text" @click="gotoDetail(scope.row)">查看</el-button></span>
                        <span v-has="'01000008'" class="action-span-btn"><el-button v-if="scope.row.noticeStatus === '00' || scope.row.noticeStatus === '10' || scope.row.noticeStatus === '40'"
                            size="mini" type="text" @click="handleDelete(scope.row)">删除</el-button></span>
                        <span v-has="'/tenderList-90'" v-if="scope.row.bidStatus === BID_STATUS_NEW && !isProjectNotice" class="action-span-btn"><el-button size="mini" type="text" @click="handleRecall(scope.row)">召回公告</el-button></span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination slot="footer"
                class="text-right"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageInfo.pageNo"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="pageInfo.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalCount">
            </el-pagination>
        </list-layout-paper>
        <colConfig :subjectType="!isProjectNotice ? 'tenderList250911' : 'tenderList20250911'" ref="colRef" :showModal="showModal" :columnsList="(!isProjectNotice ? columnsList : columnsList2)" :allColumns="(!isProjectNotice ? colJson.columns : colJson.columns2)" @getColList="getColList" @colClose="colClose"></colConfig>
        <EnrollDetailDialogs v-if="enrollDetailDialogsData.visible" :detail="enrollDetailDialogsData.detail" @onClose="onShowEnrollDetail({},false)"/>
    </div>

</template>
<script>
import { mapGetters } from 'vuex';
import dayjs from 'dayjs';
import ListLayoutPaper from '@/components/lots/listLayout/Paper';
import mSelect from '@/components/lots/otpSelect2';
import { noticeManager, delNotice, exportNotice, bidRecallNotice } from '../../../../lsrm/api/annoMana.js';
import { dictWithUrl } from '@/components/lots/api';
import colConfig from './colConfig.vue';
import EnrollDetailDialogs from './components/enrollDetailDialogs.vue';
import colJson from './colConfig.json';

const LAST_ONE_WEEK = [
    new Date(dayjs().subtract(1, 'week').format('YYYY-MM-DD HH:mm:ss')),
    new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')),
];

const LAST_ONE_MONTH = [
    new Date(dayjs().subtract(1, 'month').format('YYYY-MM-DD HH:mm:ss')),
    new Date(dayjs().format('YYYY-MM-DD HH:mm:ss')),
];

const LAST_THREE_MONTHS = [
    new Date(dayjs().subtract(3, 'month').format('YYYY-MM-DD 00:00:00')),
    new Date(dayjs().format('YYYY-MM-DD 23:59:59')),
];

const pickerOptions = {
    shortcuts: [
        {
            text: '最近一周',
            onClick(picker) {
                picker.$emit('pick', LAST_ONE_WEEK);
            }
        }, {
            text: '最近一个月',
            onClick(picker) {
                picker.$emit('pick', LAST_ONE_MONTH);
            }
        }, {
            text: '最近三个月',
            onClick(picker) {
                picker.$emit('pick', LAST_THREE_MONTHS);
            }
        }
    ]
};

export default {
    name: 'tenderList',
    components: { ListLayoutPaper, colConfig, mSelect, EnrollDetailDialogs },
    props: {
        // 公告类型 40=项目公告(查询条件、表头有差异)
        noticeType: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            colJson: colJson,
            dictData: [],
            resourceCode: '',
            frontUrl: '',
            searchInfo: {
                noticeCode: '',
                noticeTitle: '',
                noticeStatus: '',
                noticeScope: '',
                bidType: '',
                isRecall: '',
                customerTypeList : [],
                professionalCompanyList: [],
                timeRange: LAST_THREE_MONTHS
            },
            pageInfo: {
                pageNo: 1,
                pageSize: 10
            },
            valueradius: '0',
            total: 0,
            announceList: [],
            loading: false,
            exportLoading: false,
            columnNum: 100,
            showModal: false,
            columnsList: [{
                prop: 'noticeCode',
                label: '公告编号',
                width: '180'
            }, {
                prop: 'noticeTitle',
                label: '公告标题',
                width: '280'
            }, {
                prop: 'noticeStatus',
                label: '公告状态',
                width: '180'
            }, {
                prop: 'noticeType',
                label: '公告类型',
                width: '180'
            }, {
                prop: 'noticeScope',
                label: '公告范围',
                width: '180'
            }, {
                prop: 'bidType',
                label: '招标方式',
                width: '180'
            }, {
                prop: 'createTime',
                label: '发布时间',
                width: '180'
            }, {
                prop: 'professionalCompanyText',
                label: '专业公司',
                width: '180'
            }, {
                prop: 'customerTypeText',
                label: '客户类型',
                width: '180'
            }, {
                prop: 'isRecallText',
                label: '是否召回招标',
                width: '180'
            }, {
                "prop": "createUserName",
                "label": "创建人姓名",
                "width": "100"
            }, {
                "prop": "createUserCode",
                "label": "创建人账号",
                "width": "100"
            }, {
                "prop": "createTime",
                "label": "创建时间",
                "width": "180"
            }, {
                "prop": "updateUserName",
                "label": "更新人姓名",
                "width": "100"
            }, {
                "prop": "updateUserCode",
                "label": "更新人账号",
                "width": "100"
            }, {
                "prop": "updateTime",
                "label": "更新时间",
                "width": "180"
            }],
            columnsList2: [{
                prop: 'noticeCode',
                label: '公告编号',
                width: '180'
            }, {
                prop: 'noticeTitle',
                label: '公告标题',
                width: '280'
            }, {
                prop: 'noticeStatus',
                label: '公告状态',
                width: '180'
            }, {
                prop: 'noticeType',
                label: '公告类型',
                width: '180'
            }, {
                prop: 'createTime',
                label: '发布时间',
                width: '180'
            }, {
                prop: 'professionalCompanyText',
                label: '专业公司',
                width: '180'
            }, {
                prop: 'customerTypeText',
                label: '客户类型',
                width: '180'
            }, {
                prop: 'enrollDetailTotal',
                label: '报名明细',
                width: '180'
            }, {
                "prop": "createUserName",
                "label": "创建人姓名",
                "width": "100"
            }, {
                "prop": "createUserCode",
                "label": "创建人账号",
                "width": "100"
            }, {
                "prop": "createTime",
                "label": "创建时间",
                "width": "180"
            }, {
                "prop": "updateUserName",
                "label": "更新人姓名",
                "width": "100"
            }, {
                "prop": "updateUserCode",
                "label": "更新人账号",
                "width": "100"
            }, {
                "prop": "updateTime",
                "label": "更新时间",
                "width": "180"
            }],
            totalCount: 1,
            codeList: ['noticeScope', 'bidType', 'noticeType', 'noticeStatus'],
            pickerOptions,
            BID_STATUS_NEW: '00', // 招标状态-新建
            colConfigKey: 0,
            enrollDetailDialogsData: { // 报名明细弹窗数据
                visible: false,
                detail: {} // 行数据
            }
        };
    },
    mounted() {
        dictWithUrl('SU_NOTICE_STATUS,SU_NOTICE_TYPE,SU_NOTICE_SCOPE,SU_BID_TYPE,SYS_PROFESSIONAL_COMPANY,SRM_CONTRACT_IS_GROUP_CUSTOMER,SRM_YES_NO').then(item => {
            this.dictData = item.data;
            this.$refs.colRef.setConfigColumn().then((res) => {
                if(this.isProjectNotice) {
                    this.columnsList2 = res;
                    const par = this.getParams();
                    this.loadData(par);
                } else {
                    this.columnsList = res;
                }
            });
        });
    },
    methods: {
        exportNoticeFn() {
            const bidNotice = this.getParams();
            delete bidNotice.pageNo;
            delete bidNotice.pageSize;
            // 导出做的统一的，contractInfo是查询条件，moduleCode是资源编码就是用来定位表的，subjectType是唯一标识符，前端自定义，一般取表名
            const par = {
                bidNotice,
                professionalCompanyList:bidNotice.professionalCompanyList,
                customerTypeList:bidNotice.customerTypeList,
                moduleCode: this.resourceCode,
                subjectType: this.frontUrl.replace(/\//g, '')
            };
            // 公告类型的导出参数需要放在外面一层
            if(bidNotice.noticeTypeList) {
                par.noticeTypeList = bidNotice.noticeTypeList
            }
            delete par.bidNotice.customerTypeList;
            delete par.bidNotice.professionalCompanyList;
            this.exportLoading = true;
            exportNotice(JSON.stringify(par)).then(res => {
                if (res) {
                    const blob = new Blob([res], {
                        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    });
                    const objectUrl = URL.createObjectURL(blob);
                    const a = document.createElement('a');
                    a.href = objectUrl;
                    a.download = '管理端公告列表导出.xlsx';
                    a.click();
                    this.$message.success('导出成功');
                }
            }).catch(() => {
                this.$message.warning('导出失败');
            }).finally(() => {
                this.exportLoading = false;
            });
        },
        refreshFn() {
            const par = this.getParams();
            this.loadData(par);
        },
        selectType(e) {
            if (+e === 0) {
                this.searchInfo.noticeType = '';
            } else {
                this.searchInfo.noticeType = e;
            }
            const par = this.getParams();
            this.loadData(par);
            // 获取列配置
            // this.$refs.colRef.setConfigColumn().then((res) => {
            //     this.getColList(res)
            // });
        },
        searchFn() {
            this.pageInfo.pageNo = 1;
            const par = this.getParams();
            this.loadData(par);
        },
        getNoticeScope(value) {
            this.searchInfo.noticeScope = value;
        },
        getCustomerType(value) {
            this.searchInfo.customerTypeList = value;
        },
        getNoticeStatus(value) {
            this.searchInfo.noticeStatus = value;
        },
        getBidType(value) {
            this.searchInfo.bidType = value;
        },
        getProfessionalCompany(value) {
            this.searchInfo.professionalCompanyList = value;
        },
        // 是否召回公告搜索条件变更事件
        getRecall(value) {
            this.searchInfo.isRecall = value;
        },
        conversionData(list) {
            list.forEach(el => {
                el.noticeStatusText = this.dictData.SU_NOTICE_STATUS[el.noticeStatus];
                el.noticeTypeText = this.dictData.SU_NOTICE_TYPE[el.noticeType];
                el.noticeScopeText = this.dictData.SU_NOTICE_SCOPE[el.noticeScope];
                el.bidTypeText = this.dictData.SU_BID_TYPE[el.bidType] || '-';
                el.professionalCompanyText = this.dictData.SYS_PROFESSIONAL_COMPANY[el.professionalCompany];
                el.customerTypeText = this.dictData.SRM_CONTRACT_IS_GROUP_CUSTOMER[el.customerType];
                el.isRecallText = this.dictData.SRM_YES_NO[el.isRecall];
            });
        },
        handleRowDblClick(row, index) {
            this.addNotice(row);
        },
        loadData(serachObj) {
            noticeManager(serachObj).then((res) => {
                if (res && +res.code === 0) {
                    this.announceList = res.data.list;
                    this.totalCount = res.data.totalCount;
                    if (this.announceList.length > 0) {
                        this.conversionData(this.announceList);
                    }
                }
            });
        },
        addNotice(row, type) {
            if (row) {
                // 特权修改->编辑
                if (type && type === 'PRIVILEGE') {
                    this.$router.push({
                        name: 'editorNotice',
                        query: {
                            id: row.id,
                            privilege: '1',
                            isProjectNotice: this.isProjectNotice,
                        }
                    });
                }
                // 公告状态 00 10 40 ->编辑
                else if (row.noticeStatus === '00' || row.noticeStatus === '10' || row.noticeStatus === '40') {
                    this.$router.push({
                        name: 'editorNotice',
                        query: { 
                            id: row.id,
                            isProjectNotice: this.isProjectNotice,
                        }
                    });
                }
                // 查看
                else {
                    this.$router.push({
                        name: 'previewNotice',
                        query: {
                            id: row.id,
                            processId: row.processId,
                            noticeCode: row.noticeCode,
                            isProjectNotice: this.isProjectNotice,
                        }
                    });
                }
            }
            // 新增
            else {
                this.$router.push({ 
                    name: 'editorNotice',
                    query: { 
                        isProjectNotice: this.isProjectNotice,
                    }
                 });
            }
        },
        gotoDetail(row) {
            this.$router.push({
                name: 'previewNotice',
                query: { id: row.id, processId: row.processId, noticeCode: row.noticeCode }
            });
        },
        colDispose() {
            this.showModal = true;
        },
        colClose(bool) {
            this.showModal = bool;
        },
        getColList(list) {
            // 设置列配置
            if(!this.isProjectNotice){
                this.columnsList = list;
            } else {
                this.columnsList2 = list;
            }
            this.colClose();
        },
        handleCurrentChange(val) {
            this.pageInfo.pageNo = val;
            const par = this.getParams();
            this.loadData(par);
        },
        handleSizeChange(val) {
            this.pageInfo.pageSize = val;
            const par = this.getParams();
            this.loadData(par);
        },
        // 删除
        handleDelete(row) {
            this.$confirm('是否删除这条公告?', '提示', {
                confirmButtonText: '删除',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delNotice(row.id).then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('删除成功！');
                        const par = this.getParams();
                        this.loadData(par);
                    }
                });
            });
        },
        getParams() {
            const params = { ...this.pageInfo, ...this.searchInfo };
            params.startTime = params.timeRange ? dayjs(params.timeRange[0]).format('YYYY-MM-DD HH:mm:ss') : '';
            params.endTime = params.timeRange ? dayjs(params.timeRange[1]).format('YYYY-MM-DD HH:mm:ss') : '';
            delete params.timeRange;
            // 项目公告
            if(this.isProjectNotice) {
                params.noticeType = '40'
            }
            // 公告管理查询全部时要传noticeTypeList=['10','20','30']
            else if(!params.noticeType){
                params.noticeTypeList=['10','20','30']
            }
            return params;
        },
        // 召回
        handleRecall(row) {
            this.$confirm('是否召回招标公告？<br />公告召回则废弃，供应商查看时显示为 此招标已废弃', '提示', {
                dangerouslyUseHTMLString: true,
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.loading = true;
                bidRecallNotice({ noticeCode: row.noticeCode }).then((res) => {
                    if (res && +res.code === 0) {
                        this.$message.success('召回成功！');
                        const par = this.getParams();
                        this.loadData(par);
                    }
                }).finally(() => {
                    this.loading = false;
                });
            });
        },
        // 打开报名明细弹窗
        onShowEnrollDetail(row, bol = true) {
            this.enrollDetailDialogsData.detail = {...row}
            this.enrollDetailDialogsData.visible = bol
        }
    },
    computed: {
        ...mapGetters(['menus', 'currentTenant', 'applicationCode']),
        isProjectNotice(){
            if(this.noticeType === '40') {
                return 1
            }
            return 0
        }
    }
};
</script>
<style lang="less">
.tender-list {
    .list-layout .list-header .el-input {
        margin:0 15px 5px 0;
    }

    .list-layout{
        .list-header {
            .professional-company {
                margin-right: 15px;
                margin-bottom: 0;

                .el-input {
                    display: inline-block;
                    width: 170px;
                    height: 27.99px;
                }

                .el-select{
                    height: 27.99px;
                }

                .el-select__tags{
                    height: 27.99px;

                    span {
                        display:flex;
                        align-items:center;
                    }
                }

                .el-input__inner{
                    height: 27.99px !important;
                }
            }
        }
    }

    .point {
        display:inline-block;
        width:8px;
        height: 8px;
        border-radius:100%;
    }

    .srm-advance{
        display: inline-block;
        margin-right:15px;
        width: 170px;
    }

    .tab-list.el-table {
        min-height: calc(~"100vh - 248px");
        max-height: calc(~"100vh - 248px");
    }

    .otp-select {
        .el-input {
            margin-left: 0;
        }

        .el-select__input{
            margin-left: 0;
        }
    }

    .padding-left {
        margin-left: 10px;
    }

    .action-span-btn {
        display: inline-block;
        padding: 0 5px;
    }

    .header-button-btn {
        margin-left: 10px;
    }

    .header-button {
        display: flex;
        align-items: flex-start;
        margin-top: 27px;
        min-width:142px;
    }

    .header-search-top {
        margin-bottom: 10px;
    }

    .header-search-bottom {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    .recall-text-yes {
        color: #f96c5f;
    }
    .enrollDetailTotal-text {
        color: #00d082;
        cursor: pointer;
    }
}
</style>